import { getDeliverySolutions as publicGetDeliverySolutions } from './gateways-ecom-v1-delivery-rates-gateway-delivery-solutions.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const getDeliverySolutions: MaybeContext<
  BuildRESTFunction<typeof publicGetDeliverySolutions> &
    typeof publicGetDeliverySolutions
> = /*#__PURE__*/ createRESTModule(publicGetDeliverySolutions);

export {
  SubdivisionType,
  VatType,
  WeightUnit,
  PickupMethod,
  ChargeType,
  RuleType,
} from './gateways-ecom-v1-delivery-rates-gateway-delivery-solutions.universal.js';
export {
  DeliveryRatesGateway,
  GetDeliverySolutionsRequest,
  DeliverableItem,
  CatalogReference,
  PhysicalProperties,
  Address,
  AddressStreetOneOf,
  StreetAddress,
  AddressLocation,
  Subdivision,
  FullAddressContactDetails,
  VatId,
  UserPreference,
  ExternalReference,
  GetDeliverySolutionsResponse,
  DeliverySolution,
  DeliveryLogistics,
  PickupDetails,
  DeliveryTimeSlot,
  DeliveryCost,
  AdditionalCharge,
  DeliveryAllocation,
  Carrier,
  Region,
  ApplicableLineItems,
  DeliveryCarrierError,
  Details,
  DetailsKindOneOf,
  ApplicationError,
  ValidationError,
  FieldViolation,
  SystemError,
  GetDeliverySolutionsResponseNonNullableFields,
  GetDeliverySolutionsOptions,
} from './gateways-ecom-v1-delivery-rates-gateway-delivery-solutions.universal.js';
